var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13932_75279)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#B6EBFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13932_75279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 30
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.60156,
    y: 3.6001,
    width: 28.8,
    height: 28.8,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13932_75279)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13932_75279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 18,
    height: 18
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.35938,
    y: 9.36011,
    width: 17.28,
    height: 17.28,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13932_75279)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7619 24.84C22.9696 24.84 24.6633 24.0426 24.1823 20.8331L23.6221 16.4834C23.3255 14.882 22.304 14.269 21.4077 14.269H14.0792C13.1697 14.269 12.2075 14.9281 11.8648 16.4834L11.3046 20.8331C10.896 23.6801 12.5436 24.84 14.7514 24.84H20.7619Z",
    stroke: "#41B8E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6484 14.1109C14.6484 12.393 16.0411 11.0003 17.7591 11.0003C18.5864 10.9968 19.381 11.3229 19.9672 11.9067C20.5534 12.4904 20.8829 13.2837 20.8829 14.1109",
    stroke: "#41B8E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625 17.3535H15.658",
    stroke: "#41B8E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8281 17.3535H19.8611",
    stroke: "#41B8E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13932_75279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealSales);
export default __webpack_public_path__ + "static/media/realSales.fd0d0ee8b704faae6a3bb3a267d61025.svg";
export { ForwardRef as ReactComponent };